import { Link } from 'react-router-dom';
import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../css/new.css'; // Custom styles
import logo from '../images/logo1.png';

function FullNavbar() {
  const [expanded, setExpanded] = useState(false);

  const handleNavItemClick = () => {
    setExpanded(false);
  };

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top" expanded={expanded}>
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="brand" onClick={handleNavItemClick}>
          <img src={logo} alt="Hotel Celebration" />
          {/* <span>A S TRADERS</span> */}
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          style={{ color: 'black' }}
          onClick={handleToggle}
        />

        <Navbar.Collapse id="navbar-nav" className="navigate">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavItemClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/About" onClick={handleNavItemClick}>
              About
            </Nav.Link>

            <NavDropdown title="Services" id="services-dropdown">
              <NavDropdown.Item as={Link} to="/weddings" onClick={handleNavItemClick}>
                Weddings
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/engagements" onClick={handleNavItemClick}>
                Engagements
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/receptions" onClick={handleNavItemClick}>
                Receptions
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/birthdays" onClick={handleNavItemClick}>
                Birthdays
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/anniversaries" onClick={handleNavItemClick}>
                Anniversaries
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/corporate-meetings" onClick={handleNavItemClick}>
                Corporate Meetings
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/social-events" onClick={handleNavItemClick}>
                Social Events
              </NavDropdown.Item>
            </NavDropdown>



            <Nav.Link as={Link} to="/gallery" onClick={handleNavItemClick}>
              Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={handleNavItemClick}>
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default FullNavbar;